import React from 'react';
import '../LobbyIsFullModal/LobbyIsFullModal.css';
import './LobbyKickConfirmModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'LobbyKickConfirmModal';

/**
 * Подтверждение исключения игрока создателем лобби: крестик на плашке (или
 * карточке) соперника больше не исключает сразу — промах по нему выкидывал
 * игрока из лобби без возврата. Оформление — как у остальных окон лобби
 * (LobbyIsFullModal). Нажатие мимо окна — отмена
 *
 * @param {Object} props
 * @param {string} props.playerName - ник исключаемого
 * @param {function(): void} props.onConfirm
 * @param {function(): void} props.onCancel
 */
function LobbyKickConfirmModal({playerName, onConfirm, onCancel}) {
  return (
    <div className="lobby-is-full-overlay" onClick={onCancel} role="dialog" aria-modal="true">
      <div className="lobby-is-full-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="lobby-is-full-title">Исключить игрока?</h2>
        <p className="lobby-is-full-text">
          <span className="lobby-kick-confirm_name">{playerName}</span> будет исключен из лобби.
        </p>

        <div className="main-menu-buttons lobby-is-full-buttons lobby-kick-confirm_buttons">
          <PageButton
            className="lobby-kick-confirm_confirm"
            onClick={onConfirm}
            pageId={PAGE_ID}
            buttonId="confirm"
          >
            Исключить
          </PageButton>
          <PageButton onClick={onCancel} pageId={PAGE_ID} buttonId="cancel">
            Отмена
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default LobbyKickConfirmModal;
